import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link } from "react-router-dom";
import BASE_URL from "api/Api";
import "assets/theme/admin_list.css";
import { FaUsers, FaUserPlus, FaEdit, FaTrash } from "react-icons/fa";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Pagination state
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchUsers(page);
  }, [page]);

  const fetchUsers = async (currentPage) => {
    setLoading(true);
    try {
      const res = await apiFetch(
        `super_admin/user_list?page=${currentPage}&limit=${limit}`
      );

      setUsers(res.users || []);
      setTotalPages(res.pagination?.totalPages || 1);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  // handle delete user
  const handeldelete = async (user_id) => {
    try {
      await apiFetch(`super_admin/delete_user/${user_id}`, {
        method: "DELETE",
      });

      alert("User deleted successfully");
      fetchUsers(page);
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="admin-page-container">
        {/* Header */}
        <div className="admin-header-card d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center">
            <div className="admin-header-icon">
              <FaUsers />
            </div>
            <div>
              <h4 className="admin-header-title">वापरकर्ता व्यवस्थापन (User Management)</h4>
              <p className="admin-header-subtitle mb-0">
                सिस्टम वापरकर्ते, भूमिका आणि प्रवेश परवानग्या व्यवस्थापित करा
              </p>
            </div>
          </div>

          <Link to="/add_user" className="btn-admin-add">
            <FaUserPlus /> नवीन वापरकर्ता जोडा
          </Link>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-warning" role="status" />
              <p className="mt-2 text-muted fw-semibold">वापरकर्ते लोड होत आहेत...</p>
            </div>
          ) : users.length === 0 ? (
            <div className="text-center py-5 text-muted">
              कोणताही वापरकर्ता आढळला नाही.
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-admin-custom">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>वापरकर्ता (Name)</th>
                      <th>ईमेल (Email)</th>
                      <th>मोबाईल (Mobile)</th>
                      <th>भूमिका (Role)</th>
                      <th>पक्ष (Party)</th>
                      <th>प्रभाग (Ward)</th>
                      <th className="text-end">कृती (Actions)</th>
                    </tr>
                  </thead>

                  <tbody>
                    {users.map((u, index) => (
                      <tr key={u.user_id}>
                        <td className="fw-bold text-secondary">
                          {(page - 1) * limit + index + 1}
                        </td>

                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <div className="admin-avatar-chip">
                              {u.full_name?.charAt(0)?.toUpperCase() || "U"}
                            </div>
                            <strong className="text-dark">{u.full_name}</strong>
                          </div>
                        </td>

                        <td className="text-secondary">{u.email}</td>

                        <td className="text-muted">{u.mobile || "—"}</td>

                        <td>
                          <span className="badge-status badge-status-info">
                            {u.role_name}
                          </span>
                        </td>

                        <td>
                          <span className="badge bg-light text-dark border">
                            {u.party_name || "—"}
                          </span>
                        </td>

                        <td>{u.ward_name || "—"}</td>

                        <td className="text-end">
                          <div className="admin-action-group justify-content-end">
                            <Link
                              to={`/edit_user/${u.user_id}`}
                              className="btn-action-icon btn-action-edit"
                              title="संपादित करा"
                            >
                              <FaEdit />
                            </Link>

                            <button
                              className="btn-action-icon btn-action-delete"
                              title="हटवा"
                              onClick={() => {
                                if (
                                  window.confirm(
                                    "आपण निश्चितपणे हा वापरकर्ता हटवू इच्छिता?"
                                  )
                                ) {
                                  handeldelete(u.user_id);
                                }
                              }}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination Bar */}
              <div className="admin-pagination-bar">
                <span className="admin-pagination-info">
                  पृष्ठ {page} पैकी {totalPages}
                </span>

                <div className="d-flex align-items-center gap-2">
                  <button
                    className="admin-pagination-btn"
                    disabled={page === 1}
                    onClick={() => handlePageChange(page - 1)}
                  >
                    « मागील
                  </button>

                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i}
                      className={`admin-pagination-btn ${
                        page === i + 1 ? "active" : ""
                      }`}
                      onClick={() => handlePageChange(i + 1)}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button
                    className="admin-pagination-btn"
                    disabled={page === totalPages}
                    onClick={() => handlePageChange(page + 1)}
                  >
                    पुढील »
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default UserList;
